import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import "../styles/Partners.css";
import bg from "../assets/images/projects/bg.jpg";

// Import partner logos
import AlibabaLogo from "../assets/icons/partners/Alibaba.svg";
import BluLogo from "../assets/icons/partners/Blu.svg";
import DigiKalaLogo from "../assets/icons/partners/Digikala.svg";
import DominosLogo from "../assets/icons/partners/Dominos.svg";
import JabamaLogo from "../assets/icons/partners/Jabama.svg";
import KalehLogo from "../assets/icons/partners/Kaleh.svg";
import OkalaLogo from "../assets/icons/partners/Okala.svg";
import SnowaLogo from "../assets/icons/partners/Snowa.svg";
import Flytoday from "../assets/icons/partners/Flytoday.svg";

export function Partners() {
    const sliderRef = useRef(null);

    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;

        let scrollPosition = 0;
        const scrollSpeed = 1; // pixels per frame
        let animationId;

        const autoScroll = () => {
            scrollPosition += scrollSpeed;

            // When we've scrolled through half the content (original logos), reset to start
            const maxScroll = slider.scrollWidth / 2;
            if (scrollPosition >= maxScroll) {
                scrollPosition = 0;
            }

            slider.scrollLeft = scrollPosition;
            animationId = requestAnimationFrame(autoScroll);
        };

        // Start auto-scrolling
        animationId = requestAnimationFrame(autoScroll);

        // Pause on hover
        const handleMouseEnter = () => cancelAnimationFrame(animationId);
        const handleMouseLeave = () => {
            animationId = requestAnimationFrame(autoScroll);
        };

        slider.addEventListener('mouseenter', handleMouseEnter);
        slider.addEventListener('mouseleave', handleMouseLeave);

        // Cleanup
        return () => {
            cancelAnimationFrame(animationId);
            slider.removeEventListener('mouseenter', handleMouseEnter);
            slider.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);

    const partnerLogos = [
        { src: DigiKalaLogo, alt: "DigiKala" },
        { src: AlibabaLogo, alt: "Alibaba" },
        { src: SnowaLogo, alt: "Snowa" },
        { src: KalehLogo, alt: "Kaleh" },
        { src: OkalaLogo, alt: "Okala" },
        { src: JabamaLogo, alt: "Jabama" },
        { src: BluLogo, alt: "Blu" },
        { src: DominosLogo, alt: "Dominos" },
        { src: Flytoday, alt: "Flytoday" }
    ];
    return (
        <div className="partners-page">
            {/* Hero Section - Massive Typography */}
            <section className="partners-hero">
                <div className="partners-hero-background">
                    <img
                        src={bg}
                        alt="Partners"
                    />
                </div>
                <div className="partners-hero-content">
                    <h1 className="partners-hero-title">
                        PARTNERS
                    </h1>
                    <p className="partners-hero-subtitle">
                        Together We Explore
                    </p>
                </div>
            </section>

            {/* Logo Cloud Section - Scattered Layout (Desktop) / Slider (Mobile/Tablet) */}
            <section className="logo-cloud-section">
                <div className="logo-cloud-container">
                    {/* Desktop: Scattered Partner Logos */}
                    <div className="logos-grid desktop-logos">
                        {/* Row 1 */}
                        <div className="logo-item" style={{ top: '5%', left: '5%' }}>
                            <img src={DigiKalaLogo} alt="DigiKala" className="partner-logo" />
                        </div>
                        <div className="logo-item" style={{ top: '8%', left: '35%' }}>
                            <img src={AlibabaLogo} alt="Alibaba" className="partner-logo" />
                        </div>
                        <div className="logo-item" style={{ top: '5%', right: '15%' }}>
                            <img src={SnowaLogo} alt="Snowa" className="partner-logo" style={{ transform: 'scale(1.5)' }} />
                        </div>

                        {/* Row 2 */}
                        <div className="logo-item" style={{ top: '35%', left: '5%' }}>
                            <img src={KalehLogo} alt="Kaleh" className="partner-logo" />
                        </div>
                        <div className="logo-item" style={{ top: '28%', right: '5%' }}>
                            <img src={OkalaLogo} alt="Okala" className="partner-logo" />
                        </div>

                        {/* Center - CTA Button */}
                        <div className="center-cta">
                            <Link to="/contact" className="cta-button">
                                Work with Me
                            </Link>
                        </div>

                        {/* Row 3 */}
                        <div className="logo-item" style={{ bottom: '25%', left: '8%' }}>
                            <img src={JabamaLogo} alt="Jabama" className="partner-logo" />
                        </div>
                        <div className="logo-item" style={{ bottom: '28%', right: '12%' }}>
                            <img src={BluLogo} alt="Blu" className="partner-logo" />
                        </div>

                        {/* Row 4 */}
                        <div className="logo-item" style={{ bottom: '8%', left: '30%' }}>
                            <img src={DominosLogo} alt="Dominos" className="partner-logo" style={{ transform: 'scale(1.5)' }} />
                        </div>
                        <div className="logo-item" style={{ bottom: '15%', right: '30%' }}>
                            <img src={Flytoday} alt="Flytoday" className="partner-logo" style={{ transform: 'scale(2)' }} />
                        </div>
                    </div>

                    {/* Mobile/Tablet: Horizontal Slider with Infinite Scroll */}
                    <div className="mobile-slider">
                        <div className="slider-container" ref={sliderRef}>
                            <div className="slider-track">
                                {/* First set of logos */}
                                {partnerLogos.map((logo, index) => (
                                    <div key={`logo-1-${index}`} className="slider-item">
                                        <img src={logo.src} alt={logo.alt} className="partner-logo" />
                                    </div>
                                ))}
                                {/* Duplicate set for infinite loop */}
                                {partnerLogos.map((logo, index) => (
                                    <div key={`logo-2-${index}`} className="slider-item">
                                        <img src={logo.src} alt={logo.alt} className="partner-logo" />
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* CTA Button Below Slider */}
                        <div className="mobile-cta">
                            <Link to="/contact" className="cta-button">
                                Work with Me
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Partners;
